<template>
  <div class="trainers-manager">
    <grid
      ref="itemsGrid"
      :list-url="listUrl"
      :view-action-as-link="false"
      loading-message="Loading reimbursement submissions ..."
      @item-action="gridItemAction"
    />
    <teleport
      to="#vue-portal-target"
      append
    >
      <modal
        ref="filesModal"
        modal-class="wide-modal"
        :form-url="filesModalFormUrl"
        :modal-title="filesModalTitle"
      />
    </teleport>
  </div>
</template>

<script setup lang="ts">
import {ref, useTemplateRef} from 'vue'
import type { GridItem, ItemAction } from './types'
import Grid from './grid.vue'
import Modal from './modal.vue'

defineProps({
  listUrl: {default: null, type: String}
})

const filesModal = useTemplateRef("filesModal")

const filesModalTitle = ref<string>("Submitted files")
const filesModalFormUrl = ref<string | null>(null)

const gridItemAction = (item: GridItem, action: ItemAction | string): void => {
  if (typeof action !== 'string') {
    if (action.name === 'view') {
      filesModalFormUrl.value = item?.links?.view || null
      filesModalTitle.value = `${item.attributes.first_name} ${item.attributes.last_name_uppercase}`
      filesModal.value?.showModal()
    }
  }
}
</script>
